import { createFileRoute, redirect } from '@tanstack/react-router';
import { Page } from '@/components/Page/index.tsx';
import * as styles from './index.css.ts';

export const Route = createFileRoute('/_client/_auth/')({
    component: DashboardRoute,
    // After discussions with our PO, we decided to hide dashboard for now
    // for client users, since we have nothing to show on the dashboard yet.
    // Instead, they will be redirected to `/surveys`.
    beforeLoad: async () => {
        throw redirect({
            to: '/surveys',
        });
    },
});

function DashboardRoute() {
    return (
        <Page.Root>
            <div className={styles.emptyState}>
                <h1 className={styles.emptyStateTitle}>
                    現在、​ダッシュボードに​表示でき
                    <br />
                    る​情報は​まだ​ ありません。​
                </h1>
                <p className={styles.emptyStateDescription}>
                    サーベイ実施・集計レポートが増えると、
                    <br />
                    ​この​ダッシュボードに、​あなたに​役立つ情報が
                    <br />
                    ​表示されます。​
                </p>
                <div className={styles.underConstruction}>
                    <p>あなたのためだけのダッシュボード体験を準備中です！</p>
                </div>
            </div>
        </Page.Root>
    );
}
